export const modal = (modal: HTMLElement, modalOpen: HTMLButtonElement, modalClose: HTMLButtonElement) => {
    
    if (modal) {
        if (modalOpen) {
            modalOpen.addEventListener('click', () => {
                modal.classList.add('open');
            })
        }
        
        if (modalClose) {
            modalClose.addEventListener('click', () => {
                modal.classList.remove('open');
                modal.className.includes("onboarding") && localStorage.setItem("isOnboardingDone", "true");
            })
        }
    }
}